module.exports = __webpack_public_path__ + "img/infograph_5.9df3b417.png";